module.exports = __webpack_public_path__ + "static/media/FIL.d3871728.svg";